import Heartbeat2Fill from '@/assets/icons/heartbeat_2_fill.svg?component';

import type { SidebarLevelConfig } from './types';

/** Cage sub-level: the wound insight pages under a pen. */
export const woundsLevel: SidebarLevelConfig = {
    level: 'wounds',
    matchPattern: '/c/:clientId/location/:locationId/pen/:cageId/welfare/wounds',
    back: {
        title: 'sidebarItems.wounds.backTitle',
        urlTemplate: '/c/:clientId/location/:locationId/pen/:cageId',
    },
    items: [
        {
            id: 'wounds-level',
            label: 'sidebarItems.wounds.woundsTitle',
            analyticsLabel: 'Wound insight',
            path: '',
            icon: Heartbeat2Fill,
            exact: true,
            visibility: {
                requiresLicenses: ['FISH_HEALTH.MIN'],
                requiresBioscopeV1: true,
            },
            children: [
                {
                    id: 'wounds-detections',
                    label: 'sidebarItems.wounds.woundsDetections',
                    analyticsLabel: 'Wound detections',
                    path: '/detections',
                    exact: true,
                    visibility: {
                        requiresLicenses: ['FISH_HEALTH.MIN'],
                        requiresBioscopeV1: true,
                    },
                },
                {
                    id: 'wounds-graphs',
                    label: 'sidebarItems.wounds.woundsGraphs',
                    analyticsLabel: 'Graphs',
                    path: '/graphs',
                    exact: true,
                    visibility: {
                        requiresLicenses: ['FISH_HEALTH.MIN'],
                        requiresBioscopeV1: true,
                    },
                },
            ],
        },
    ],
};
